import AdminChargeSelect from "../../../../common/AdminChargeSelect";
import { calculateNetReceive } from "../utils/pricingCalculations";

const blockWheelOnNumberInput = (event) => {
  event.currentTarget.blur();
};

const PAX_ROWS = [
  { key: "adult", label: "Adult", required: true },
  { key: "child", label: "Child", required: true },
  { key: "infant", label: "Infant", required: false },
];

const BasePriceSection = ({
  basePrice,
  basePriceErrors,
  onPaxChange,
  isBasePriceSaved,
  isFormComplete,
}) => {
  const adultPrice = basePrice?.adult?.basePrice ?? "";
  const adultAdminFee = basePrice?.adult?.adminFee ?? "";
  const netReceive = calculateNetReceive(adultPrice, adultAdminFee);

  return (
    <section className="rounded-xl border border-gray-100 bg-slate-50/40 p-5">
      <div className="mb-4">
        <h3 className="text-sm font-bold text-gray-900">Base Price</h3>
        <p className="text-sm text-gray-500 mt-0.5">
          Default price when no seasonal rate applies. Days without rates allow
          enquiry only.
        </p>
      </div>

      <div className="space-y-4">
        {PAX_ROWS.map(({ key, label, required }) => (
          <div
            key={key}
            className="grid grid-cols-1 sm:grid-cols-2 gap-4 pb-4 border-b border-gray-100 last:border-0 last:pb-0"
          >
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">
                {label} price{required && " "}
                {required && <span className="text-red-500">*</span>}
              </label>
              <div className="relative">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                  ₹
                </span>
                <input
                  type="text"
                  inputMode="decimal"
                  value={basePrice?.[key]?.basePrice ?? ""}
                  onChange={(e) =>
                    onPaxChange(key, "basePrice", e.target.value)
                  }
                  onWheel={blockWheelOnNumberInput}
                  className={`w-full h-10 border rounded-md pl-7 pr-3 text-sm focus:ring-1 focus:ring-blue-400 ${
                    basePriceErrors?.[key]?.basePrice ? "border-red-500" : ""
                  }`}
                  placeholder="0.00"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">
                {label} admin fee{required && " "}
                {required && <span className="text-red-500">*</span>}
              </label>
              <AdminChargeSelect
                value={basePrice?.[key]?.adminFee ?? ""}
                onChange={(value) => onPaxChange(key, "adminFee", value)}
                error={Boolean(basePriceErrors?.[key]?.adminFee)}
                allowEmpty={key === "infant"}
                required={key !== "infant"}
                className="!h-10 !py-0"
              />
            </div>
          </div>
        ))}
      </div>

      {adultPrice !== "" && adultPrice != null && (
        <p className="mt-3 text-sm text-gray-500">
          Adult net receive:{" "}
          <span className="font-semibold text-green-600">₹{netReceive}</span>
        </p>
      )}

      <p className="mt-4 text-xs text-gray-500">
        {isBasePriceSaved ? (
          <span className="text-green-600 inline-flex items-center gap-1">
            <i className="fi fi-rr-check-circle"></i>
            Base price saved
          </span>
        ) : isFormComplete ? (
          <span className="text-amber-600">
            Complete — saved when you click Save Pricing below
          </span>
        ) : (
          "Fill in adult and child prices for each stay category."
        )}
      </p>
    </section>
  );
};

export default BasePriceSection;
